export default __webpack_public_path__ + "static/media/biometrics_new1x.eb37347c.png";